var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_494_23228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0111 2.77531C13.6562 2.42036 13.0828 2.42036 12.7279 2.77531L8.27734 7.21672L3.82683 2.76621C3.47188 2.41126 2.8985 2.41126 2.54356 2.76621C2.18861 3.12116 2.18861 3.69454 2.54356 4.04949L6.99407 8.5L2.54356 12.9505C2.18861 13.3055 2.18861 13.8788 2.54356 14.2338C2.8985 14.5887 3.47188 14.5887 3.82683 14.2338L8.27734 9.78328L12.7279 14.2338C13.0828 14.5887 13.6562 14.5887 14.0111 14.2338C14.3661 13.8788 14.3661 13.3055 14.0111 12.9505L9.56062 8.5L14.0111 4.04949C14.357 3.70364 14.357 3.12116 14.0111 2.77531Z",
    fill: "#002466"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_494_23228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(2.27734 2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8c43fed1caa55c83478feea451c641db.svg";
export { ForwardRef as ReactComponent };